import { type ReactNode } from "react";
import { Button } from "@/components/ui/button";

type CookieSettingsLinkProps = {
  variant?: "ghost" | "link" | "outline";
  size?: "sm" | "default";
  children?: ReactNode;
};

export function CookieSettingsLink({ variant = "ghost", size = "sm", children = "Cookie settings" }: CookieSettingsLinkProps): JSX.Element {
  const handleClick = () => {
    window.dispatchEvent(new CustomEvent("cookiekit:open-preferences"));
  };

  return (
    <Button type="button" variant={variant} size={size} onClick={handleClick} aria-haspopup="dialog" className="rounded-full">
      {children}
    </Button>
  );
}

export default CookieSettingsLink;
